import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TenantWhatsAppSettings } from '../../../shared/services/tenant.service';

@Component({
  selector: 'black-whatsapp-widget',
  templateUrl: './whatsapp-widget.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class WhatsappWidgetComponent {
  @Input() whatsApp?: TenantWhatsAppSettings;
  @Input() tenantName?: string;
  @Input() theme: 'modern' | 'warm' | 'bold' = 'modern';

  get isEnabled(): boolean {
    return Boolean(
      this.whatsApp?.enabled &&
        this.whatsApp?.phoneNumber?.trim() &&
        this.whatsApp?.floatingButton !== false
    );
  }

  get buttonText(): string {
    return this.whatsApp?.buttonText || 'Inquire on WhatsApp';
  }

  get whatsAppLink(): string {
    const raw = (this.whatsApp?.phoneNumber || '').trim();
    if (!raw) return '#';

    // If tutor provided a full WhatsApp or chat invite link
    if (raw.startsWith('http://') || raw.startsWith('https://')) {
      return raw;
    }
    if (raw.startsWith('chat.whatsapp.com') || raw.startsWith('wa.me')) {
      return `https://${raw}`;
    }

    // Extract digits
    let digits = raw.replace(/[^0-9]/g, '');

    // Handle local Sri Lankan numbers like 0771234567 -> 94771234567
    if (digits.startsWith('0') && digits.length === 10) {
      digits = '94' + digits.substring(1);
    }

    const message = encodeURIComponent(
      this.whatsApp?.message ||
        `Hi, I would like to inquire about joining classes at ${this.tenantName || 'your academy'}.`
    );

    return digits ? `https://wa.me/${digits}?text=${message}` : '#';
  }

  openWhatsApp(): void {
    if (this.whatsAppLink && this.whatsAppLink !== '#') {
      window.open(this.whatsAppLink, '_blank');
    }
  }
}
